/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Input, Button, FallbackImage } from 'components';
import { CloseIcon, UserIcon } from 'assets/icons';
import moment from 'moment';

type ModalProps = {
	file: File | null
	onClose: () => void
	modal_data: any;
}

const ModalDNI = ({ file, onClose, modal_data }: ModalProps) => {
  const { blob, form } = useModal(file);
  const [isPdf, setIsPdf] = useState(false);

  useEffect(() => {
	    if (blob && blob.startsWith('blob:')) {
	        fetch(blob)
	            .then(res => {
	                const type = res.headers.get('content-type');
	                setIsPdf(type === 'application/pdf');
	            })
	            .catch(() => setIsPdf(false));
	    }
	}, [blob]);

	return (
		<div id="modal-photo-data">
			<button className="close" onClick={onClose}>
				<img src={CloseIcon} alt="Close" />
			</button>

			<section>
				<p className="title">Cédula de Identidad</p>
				{
					isPdf ? (
						<div style={{
							width: '100%',
							height: '350px',
							overflow: 'hidden',
							border: '1px solid #ccc'
						}}>
							<iframe src={ blob } style={{ border: 'none', width: '100%', height: '406px', marginTop: '-56px' }} />
						</div>
					) : (
						<div className="photo-wrapper">
							<FallbackImage
								src={blob}
								placeholder={UserIcon}
								className="fb-img"
								placeholderClassName="fb-img-placeholder"
							/>
						</div>
					)
				}

				<div className="input-group">
					<Input
						label="Nombres"
						value={modal_data?.name}
						onChange={() => {}}
						disabled
					/>
					<Input
						label="Apellidos"
						value={modal_data?.lastname}
						onChange={() => {}}
						disabled
					/>
					<Input
						label="Cédula"
						value={modal_data?.document}
						onChange={() => {}}
						disabled
					/>
					<Input
						label="Nacionalidad"
						value={modal_data?.nationality?.name}
						onChange={() => {}}
						disabled
					/>
					<Input
						label="Fecha de nacimiento"
						value={modal_data?.birthdate ? moment(modal_data?.birthdate).format('DD/MM/YYYY') : ''}
						onChange={() => {}}
						disabled
					/>
				</div>
			</section>

			<section className="actions">
				<Button className="back" color="primary flat rounded-full" onClick={onClose}>
					Volver
				</Button>
			</section>
		</div>
	)
}

const useModal = (file: File | null) => {
	const empty = {
		name: '',
		lastname: '',
		dni: '',
		nationality: '',
		birthday: '',
	};

  const [blob, setBlob] = useState('');
  const [form, setForm] = useState(empty);

  const fetchData = () => {
    try {
      // Obtiene la información de la imagen
      setForm({
        name: 'León',
        lastname: 'Reily',
        dni: '20999999',
        nationality: 'Venezolano',
        birthday: '19/2/09',
      });

    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
		if (file) {
      setBlob(URL.createObjectURL(file));
      fetchData();
    }
  }, [file]);

  return {
		blob,
		form,
  }
}

export default ModalDNI;
